import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
// import { useContext, useEffect, useState } from "react";
import QuestionMarkIcon from "../../../../assets/icons/QuestionMark.svg";
import ATQuestionsIcon from "../../../../assets/icons/ATQuestions.svg";
import ChronometerIcon from "../../../../assets/icons/ChronoMeter.svg";
// import AuthContext from "../../../../auth/AuthContext";

const UserAssessmentTypeCard = ({ data }) => {
  const navigate = useNavigate();
  const { assessmentName } = useParams();
  // const authContext = useContext(AuthContext);
  // const [permissions, setPermissions] = useState({});

  const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  };

const onEditHandler = (e) => {
  e.preventDefault();
  const assessmentId =  data.id || sessionStorage.getItem("assessmentId");
  sessionStorage.setItem("assessmentId", assessmentId);

  navigate(`/assessments/${assessmentName}/${data.type.toLowerCase()}/confirm-start`, {
    state: { id: assessmentId },
  });
};

const onViewHandler = (e) => {
  e.preventDefault();
  const assessmentId = data.id  ||  sessionStorage.getItem("assessmentId");
  sessionStorage.setItem("assessmentId", assessmentId);

  navigate(`/assessments/${assessmentName}/review-${data.type.toLowerCase()}`, {
    state: { id: assessmentId },
  });
};


  // useEffect(() => {
  //   const assessmentAccess = authContext.getPermissions("assessments");
  //   if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
  //     navigate("/");
  //   }
  //   setPermissions({
  //     showAdd: assessmentAccess.some((f) => f.access.includes(2)),
  //     showEdit: assessmentAccess.some((f) => f.access.includes(3)),
  //     showDelete: assessmentAccess.some((f) => f.access.includes(4)),
  //   });
  // }, [authContext, navigate]);

  return (
    <div
      className="card border-0 shadow p-3 p-lg-4 h-100"
      style={{ minHeight: "100px" }}
    >
      <div
        className="d-flex flex-row align-items-center gap-3"
        style={{
          color: "#fff",
          minHeight: "87px",
          backgroundImage: `url('./../../../../assets/icons/ATHeader.svg')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
        }}
      >
        <h6 className="ms-3 mb-0 lh-base">{data.type}</h6>
      </div>

      <div className="progress mt-3" style={{ height: "10px" }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${data.score}%` }}
          aria-valuenow={data.score}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>

      {data.type === "MCQ" && (
        <div className="d-flex justify-content-start mb-3">
          <div className="fw-light" style={{ fontSize: "13px" }}>
            {data.correctMCQAnswers}/{data.totalQuestions}
          </div>
        </div>
      )}

      {data.type === "Practical" && (
        <div className="d-flex justify-content-start mb-3">
          <div className="fw-light" style={{ fontSize: "13px" }}>
            {data.score}/{data.totalPracticalScore}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-between mb-4">
        <div className="fw-light" title="No of Questions">
          <img
            src={QuestionMarkIcon}
            alt="No of Questions"
            className="w-4 h-4 hover:opacity-70  me-1 mb-1"
          />{" "}
          {data.totalQuestions}
        </div>
        <div className="fw-light" title="Duration">
          <img
            src={ChronometerIcon}
            alt="Duration"
            className="w-4 h-4 hover:opacity-70  me-1 mb-1"
          />{" "}
          {minutesToTime(data.duration)}
        </div>
      </div>
      {data.type === "MCQ" && data.isMCQCompleted === true && (
        <div className="d-flex justify-content-between mb-4">
          <div className="fw-light" title="Original Score">
            <img
              src={ATQuestionsIcon}
              alt="Marks Icon"
              className="w-4 h-4 hover:opacity-70  me-1 mb-1"
            />{" "}
            {data.correctMCQAnswers}/{data.totalQuestions}
          </div>
          <div className="fw-light" title="Confident Score">
            <img
              src={ATQuestionsIcon}
              alt="Marks Icon"
              className="w-4 h-4 hover:opacity-70  me-1 mb-1"
            />{" "}
            {data.mcqConfidentScore}/{data.totalQuestions}
          </div>
        </div>
      )}
      {data.type === "Practical" && data.isPracticalCompleted === true && (
        <div className="d-flex justify-content-start mb-4">
          <div className="fw-light" title="Score">
            <img
              src={ATQuestionsIcon}
              alt="Marks Icon"
              className="w-4 h-4 hover:opacity-70  me-1 mb-1"
            />{" "}
            {data.score}/{data.totalPracticalScore}
          </div>
        </div>
      )}

      {((data.type === "MCQ" && !data.isMCQCompleted) ||
        (data.type === "Practical" && !data.isPracticalCompleted)) && (
          <div className="d-flex justify-content-center mb-1">
            <button
              className="px-5 py-2 rounded-pill btn btn-outline"
              style={{ width: "100%" }}
              onClick={onEditHandler}
            >
              Start
            </button>
          </div>
        )}

      {data.reviewAvailable &&
        ((data.type === "MCQ" && data.isMCQCompleted === true) ||
          (data.type === "Practical" &&
            data.isPracticalCompleted === true)) && (
          <div className="d-flex justify-content-center mb-1">
            <Button
              variant="outline-success"
              className="px-5 py-2 rounded-pill"
              style={{
                width: "100%",
              }}
              onClick={onViewHandler}
            >
              Review
            </Button>
          </div>
        )}
    </div>
  );
};

export default UserAssessmentTypeCard;
